export const environment = {
  production: false,
  env: 'A',
  apiUrl: 'https://api-acc.skillcentral.nl/api'
};
